'use client';

import Link from 'next/link';
import { Home, Mail, Compass, ArrowLeft } from 'lucide-react';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-sand text-ink flex items-center justify-center px-6">
      <div className="max-w-2xl w-full text-center">
        <div className="mb-8">
          <h1 className="font-display text-9xl font-semibold text-ink-blue mb-4">
            404
          </h1>
          <h2 className="font-display text-3xl md:text-4xl font-semibold text-ink mb-4">
            Page Not Found
          </h2>
          <p className="text-xl text-body mb-8">
            The page you&apos;re looking for doesn&apos;t exist or has been moved.
          </p>
        </div>

        {/* Navigation Options */}
        <div className="grid md:grid-cols-3 gap-4 mb-8">
          <Link
            href="/"
            className="group flex flex-col items-center gap-3 p-6 bg-card hover:bg-sand-2 rounded-lg border border-line hover:border-ink-blue transition-all duration-300"
          >
            <Home className="w-8 h-8 text-ink-blue group-hover:scale-110 transition-transform" />
            <span className="font-semibold">Home</span>
          </Link>

          <Link
            href="/ai-adoption"
            className="group flex flex-col items-center gap-3 p-6 bg-card hover:bg-sand-2 rounded-lg border border-line hover:border-ink-blue transition-all duration-300"
          >
            <Compass className="w-8 h-8 text-ink-blue group-hover:scale-110 transition-transform" />
            <span className="font-semibold">AI Adoption</span>
          </Link>

          <Link
            href="/contact"
            className="group flex flex-col items-center gap-3 p-6 bg-card hover:bg-sand-2 rounded-lg border border-line hover:border-ink-blue transition-all duration-300"
          >
            <Mail className="w-8 h-8 text-ink-blue group-hover:scale-110 transition-transform" />
            <span className="font-semibold">Contact</span>
          </Link>
        </div>

        {/* Back Button */}
        <button
          onClick={() => window.history.back()}
          className="inline-flex items-center gap-2 text-caption hover:text-ink-blue transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          Go back to previous page
        </button>
      </div>
    </div>
  );
}
